import { render, staticRenderFns } from "./slidenav.vue?vue&type=template&id=f79b90ae&"
import script from "./slidenav.vue?vue&type=script&lang=js&"
export * from "./slidenav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports